/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'se-engine-group';

export const vCenterModalBreadcrumbTitle = `${prefix}.vCenterModalBreadcrumbTitle`;
export const updateSuccessfulLabel = `${prefix}.updateSuccessfulLabel`;
export const updateFailedLabel = `${prefix}.updateFailedLabel`;
export const inProgressLabel = `${prefix}.inProgressLabel`;
export const updateStoppedLabel = `${prefix}.updateStoppedLabel`;
export const runningPrechecksLabel = `${prefix}.runningPrechecksLabel`;
export const initializingLabel = `${prefix}.initializingLabel`;

export const ENGLISH = {
    [vCenterModalBreadcrumbTitle]: 'vCenter',
    [updateSuccessfulLabel]: 'Update Successful',
    [updateFailedLabel]: 'Update Failed',
    [inProgressLabel]: 'In Progress',
    [updateStoppedLabel]: 'Update Stopped',
    [runningPrechecksLabel]: 'Running Pre-checks',
    [initializingLabel]: 'Initializing',
};
